export var config = {
  datacamp_url: 'https://www.datacamp.com'
};